// File: src/components/common/AgentAvatar.jsx
import React from 'react';
import { Avatar } from '@mui/material';
import agentAvatarImage from '../../assets/ws_face.webp';

const AgentAvatar = () => (
  <Avatar
    src={agentAvatarImage}
    alt="Assistant Avatar"
    sx={{
      border: (theme) => `3px solid ${theme.palette.primary.main}`,
      '& img': { transform: 'scale(1.35)' },
    }}
  />
);

export default AgentAvatar;